export const CART_ADD_ITEM_FAIL = 'CART_ADD_ITEM_FAIL';
export const CART_ADD_ITEM = 'CART_ADD_ITEM';
export const CART_REMOVE_ITEM = 'CART_REMOVE_ITEM';
export const CART_SAVE_SHIPPING_ADDRESS = 'CART_SAVE_SHIPPING_ADDRESS';
export const CART_SAVE_PAYMENT_METHOD = 'CART_SAVE_PAYMENT_METHOD';
export const CART_EMPTY = 'CART_EMPTY';
export const CART_SAVE_TARJETA = 'CART_SAVE_TARJETA';
export const CART_GET_PROMOS = 'CART_GET_PROMOS';
export const  CART_REMOVEPORID_ITEM= 'CART_REMOVEPORID_ITEM';
export const   CART_SAVE_HORARIO= 'CART_SAVE_HORARIO';